// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4":"11cf0f33","122":"7677f8c7"}[chunkId] + ".chunk.css";
};